<template functional>
  <div class="home">
    <section class="top">
      <div class="header">
        <div class="logo">
          <img src="~@/assets/logo-no-text.svg" width="100%" height="100%" />
        </div>
        <div class="darksplit"></div>
        <div class="header-svg clouds"></div>
        <div class="header-svg climbing">
          <img src="~@/assets/header-climbing.svg" width="100%" height="100%" />
        </div>
        <div class="header-svg topo">
          <img src="~@/assets/header-topo.svg" width="100%" height="100%" />
        </div>
        <div class="container center-content">
          <h1 class="title is-1 has-text-centered" ref="logo" data-aos="fade-up">Sneller en leuker woordjes leren voor hogere cijfers</h1>
          <h2 class="title is-4 headertext has-text-centered pb-4" data-aos="fade-up">Met dit overhoorprogramma leer je leuk en snel de woordjes die je moet kennen. Met Ikleeralles.nl is overhoren niet meer saai!</h2>
          <div class="buttons has-text-centered">
            <b-button tag="router-link" to="/login" type="is-light" size="is-medium" data-aos="fade-up" icon-left="key" class="has-text-weight-bold">Inloggen</b-button>
            <b-button tag="router-link" to="/aanmelden" type="is-primary" size="is-medium" data-aos="fade-up" icon-left="account-plus" class="has-text-weight-bold">Registreren</b-button>
          </div>
        </div>
      </div>
    </section>
    <section class="hero">
      <div class="hero-body">
        <div class="container has-text-centered" data-aos="fade-up">
          <h3 class="title is-4 has-text-grey" style="margin-bottom: 10px">91% van de scholieren haalt hogere punten met Ikleeralles.nl</h3>
          <h3 class="title is-2 anotherhand">Start nu gratis met leren!</h3>
        </div>
      </div>
    </section>
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column is-half">
              <img alt="woordenlijst maken" ref="image2" src="@/assets/screenshots/lijstmaken.png" class="pr-5" width="100%" height="100%" />
            </div>
            <div class="column is-half">
              <div class="lead" data-aos="fade-left">
                <h1 class="title">
                  Woordenlijsten invullen.
                  <span class="anotherhand">Sneller dan ooit</span>
                </h1>
                <p class="is-size-4">
                  Ook op Ikleeralles maak je woordenlijsten door simpelweg de woorden in te vullen.
                  <br />
                  <strong>Woordenlijst maken:</strong> Je maakt makkelijk een woordenlijst door de woordjes en vertaling in te vullen. Veel woordjes worden automatisch vertaald. Hierdoor kan het invullen tot wel twee keer sneller gaan dan je gewend bent.
                  <br />
                  <strong>Talen:</strong> Je kiest zelf het onderwerp van iedere kolom. Dit betekent dat je jezelf kunt overhoren in alle talen. Na het invullen worden de woordjes zelfs automatisch vertaald!
                  <br />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero is-white">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column is-half">
              <div class="lead" data-aos="fade-right">
                <h1 class="title">
                  Overhoren.
                  <span class="anotherhand">Zoals je gewend bent</span>
                </h1>
                <p class="is-size-4">
                  Het overhoren van woordjes is uiteraard ook mogelijk. Met verschillende instellingen kun jij de overhoring precies laten verlopen zoals jij wilt.
                  <br />
                  <strong>Intypen of in gedachten:</strong> Bij het overhoren heb je de keuze om het goede antwoord in te typen of ouderwets op papier te werken.
                  <br />
                  <strong>Uitgebreid overhoren:</strong> Je kunt jezelf overhoren totdat je alle antwoorden goed hebt.
                  <br />
                  <strong>Resultaten:</strong> Na je overhoring krijg je uitgebreide resultaten. Je kunt onder andere zien hoevaak je ieder woord fout hebt gedaan. Van je fouten kun je zelfs een nieuwe lijst maken!
                </p>
              </div>
            </div>
            <div class="column is-half">
              <img alt="woordjes overhoren" ref="image1" src="@/assets/screenshots/overhoren.png" class="pl-5" width="100%" height="100%" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-2 has-text-centered mb-6">Wat anderen zeggen...</h1>
          <div class="columns">
            <div class="column">
              <div class="card card-review has-text-centered" data-aos="zoom-out">
                <h1 class="title is-5">Saskia</h1>
                <b-icon icon="star" class="orange"/>
                <b-icon icon="star" class="orange"/>
                <b-icon icon="star" class="orange"/>
                <b-icon icon="star" class="orange"/>
                <b-icon icon="star" class="orange"/>
                <p>“Ikleeralles.nl is een makkelijk leerplatform waar ik erg tevreden over ben."</p>
              </div>
            </div>
            <div class="column">
              <div class="card card-review has-text-centered" data-aos="zoom-out">
                <h1 class="title is-5">Pieter</h1>
                <b-icon icon="star" class="orange"/>
                <b-icon icon="star" class="orange"/>
                <b-icon icon="star" class="orange"/>
                <b-icon icon="star" class="orange"/>
                <b-icon icon="star" class="orange"/>
                <p>"Het team van Ikleeralles.nl reageert heel snel via Discord als ik ergens tegenaan loop."</p>
              </div>
            </div>
            <div class="column">
              <div class="card card-review has-text-centered" data-aos="zoom-out">
                <h1 class="title is-5">Niek</h1>
                <b-icon icon="star" class="orange"/>
                <b-icon icon="star" class="orange"/>
                <b-icon icon="star" class="orange"/>
                <b-icon icon="star" class="orange"/>
                <b-icon icon="star-half-full" class="orange"/>
                <p>"Het is een simpel programma dat ik zeker kan aanraden. Het heeft mijn middelbare school gered!"</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="container">
      <div id="cta" class="has-text-centered" data-aos="zoom-in">
        <h1 class="title is-1">Aan de slag</h1>
        <p class="is-size-5">Maak meteen een gratis account om te beginnen met leren</p>
        <b-button size="is-large" tag="router-link" to="/aanmelden" outlined>Aanmelden</b-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "home",
};
</script>

<style lang="scss" scoped>
.anotherhand {
  font-size: 2.8rem;
}
.top {
  padding-bottom: 50px;

  .header {
    background: #4189f4;
    mask: none;
    margin-top: -80px;
    position: relative;
    z-index: 2;
    height: 80vh;
    -o-object-fit: cover;
    object-fit: cover;
    width: 100%;
    padding-bottom: 150px;
    .title {
      color: #fff;
    }
    .logo {
      position: absolute;
      z-index: 100;
      left: 20px;
      top: 10px;
      height: 70px;
      width: 100px;
      padding: 20px 0;
      img {
        max-height: 100%;
      }
      @media only screen and (max-width: 1024px) {
        display: none;
      }
    }
    .darksplit {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #1d73f4;
      clip-path: polygon(0 0, 100% 0, 100% 19%, 0 81%);
    }
    .buttons {
      justify-content: center;
      .button {
        border: 0;
        border-radius: 50px;
        margin: 10px 15px;
        -webkit-box-shadow: 0px 0px 15px 5px #000000;
        box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.2);
      }
    }
    .header-svg {
      position: absolute;
      img {
        width: 100%;
      }
      &.clouds {
        width: 100%;
        height: 100%;
        background: url("~@/assets/header-clouds.svg");
      }
      &.topo {
        width: 400px;
        height: auto;
        bottom: -5px;
        left: -50px;

        @media only screen and (max-width: 1200px) {
          left: -150px;
        }
        @media only screen and (max-width: 900px) {
          right: -50px;
          left: auto;
          width: 300px;
        }
        @media only screen and (min-width: 1500px) {
          width: 500px;
        }
        @media only screen and (min-width: 1700px) {
          width: 600px;
        }
      }
      &.climbing {
        width: 400px;
        bottom: -5px;
        right: -100px;
        @media only screen and (max-width: 1200px) {
          right: -150px;
        }
        @media only screen and (max-width: 900px) {
          display: none;
        }
        @media only screen and (min-width: 1500px) {
          width: 500px;
        }
        @media only screen and (min-width: 1700px) {
          width: 600px;
        }
      }
    }
    .container {
      display: flex;
      flex-direction: column;
      max-width: 60%;
      height: 80vh;
      justify-content: center;
      @media only screen and (max-width: 1100px) {
        max-width: 80%;
      }
      @media only screen and (max-width: 500px) {
        max-width: 100%;
      }
      @media only screen and (max-width: 900px) {
        margin: 0;
        h1,
        h2 {
          text-align: left !important;
        }
        h1 {
          font-size: 2rem;
        }
        h2 {
          font-size: 1rem;
        }
        .buttons {
          justify-content: start;
          .button {
            margin-left: 0 !important;
          }
        }
      }
    }
  }

  .footer a {
    color: #fff !important;
  }
}

.hero {
  margin-bottom: 100px;
}

.lead {
  padding: 0 10px;
}

.button {
  height: 2.75em;
  padding-left: 1em;
  padding-right: 1em;
  &.is-text {
    text-decoration: none;
    color: #fff;
    &:hover,
    &:active,
    &:focus {
      background: transparent;
      text-decoration: underline;
    }
  }
}

.headertext {
  font-weight: 400;
  opacity: 0.8 !important;
}

.card-review {
  padding: 40px 60px;
  border-radius: 15px;
  .title {
    margin-top: 20px;
  }
}

#cta {
  width: 100%;
  background: #7c7b7b;
  padding: 100px 20px;
  border-radius: 30px;
  background: linear-gradient(
    90deg,
    rgba(252, 114, 52, 1) 0%,
    rgba(199, 36, 0, 1) 100%
  );
  margin-bottom: 200px;
  .title,
  p {
    color: #fff;
  }
  .button.is-outlined {
    background: transparent;
    margin-top: 40px;
    color: #fff;
    border-radius: 100px;
    padding: 10px 50px;
    transition: all 0.2s;
    border: 2px solid #fff;
    &:hover {
      background: #fff;
      color: #fc7234;
      border: none;
    }
  }
}

@media only screen and (max-width: 1500px) {
  .full-page {
    .text {
      width: 40%;
    }
  }
}
@media only screen and (max-width: 1200px) {
  .full-page {
    .text {
      width: 50%;
    }
  }
}
@media only screen and (max-width: 950px) {
  .full-page {
    .text {
      width: 70%;
    }
  }
  .is-size-4 {
    font-size: 1.3rem !important;
  }
}
@media only screen and (max-width: 700px) {
  .full-page {
    .text {
      width: 90%;
    }
  }
}
@media only screen and (max-width: 550px) {
  .full-page {
    .text {
      padding: 50px;
    }
  }
  .is-size-4 {
    font-size: 1.1rem !important;
  }
}
</style>
